import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { NominativeHolderComponent } from '../components/shared/nominative-holder/nominative-holder.component';

/**
 * Puerta de los eventos con entradas nominativas en el flujo de compra.
 *
 * Existe como servicio porque hay dos caminos para añadir al carrito —sin mapa
 * desde HoursDatesEventComponent y con mapa desde SeatsPanelComponent— y la
 * orquestación tiene que ser la misma en los dos.
 */
@Injectable({
  providedIn: 'root'
})
export class NominativeService {

  constructor(private dialog: MatDialog) { }

  /**
   * ¿El evento emite entradas nominativas?
   */
  isNominative(event: any): boolean {
    return !!event?.nominative_tickets;
  }

  /**
   * Pide y guarda los datos del titular antes de añadir al carrito.
   *
   * En un evento no nominativo no hace nada y deja pasar. En uno nominativo
   * abre el diálogo siempre, con los datos precargados del perfil, para que el
   * usuario confirme con qué nombre se emitirá la entrada antes de que quede
   * congelada en el pedido.
   *
   * Requiere que el usuario ya esté identificado: el diálogo escribe en su
   * perfil. Quien lo llama debe resolver el login antes.
   *
   * @returns Observable que emite `true` si se puede continuar con la compra, y
   *          `false` si el usuario ha cancelado.
   */
  ensureHolderData(event: any): Observable<boolean> {
    if (!this.isNominative(event)) {
      return of(true);
    }

    // Ancho explícito: `.info-dialog` solo fija un min-width, así que sin esto
    // el diálogo se estira a todo el viewport.
    const dialogRef = this.dialog.open(NominativeHolderComponent, {
      panelClass: ['info-dialog', 'dialog-nominative-holder'],
      width: '440px',
      maxWidth: '92vw',
      disableClose: true
    });

    return dialogRef.afterClosed().pipe(map((saved) => saved === true));
  }
}
